<template>
    <a-modal :title="form.subsId ? '修改' : '新增' + '工作人员信息'" :visible="visible" :confirm-loading="confirmLoading"
        @ok="handleOk" @cancel="handleCancel" width="650px" :maskClosable="false">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-model-item label="工作人员昵称（姓名）" prop="username">
                <a-input v-model="form.username" placeholder="建议姓名加职位如：张三（管家）" />
            </a-form-model-item>
            <a-form-model-item label="工作人员手机号" prop="phonenumber">
                <a-input v-model="form.phonenumber" :disabled="!!form.id" placeholder="请输入工作人员" />
            </a-form-model-item>
            <a-form-model-item label="号码池" prop="pool_key">
                <a-select v-model="form.pool_key" placeholder="请选择号码池" :disabled="!!form.subsId">
                    <a-select-option v-for="(item, index) in poollist" :key="index" :value="item.pool_key"
                        :disabled="item.disabled">{{ item.pool_name
                        }}</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="隐私通话过期时间" prop="expiration">
                <a-date-picker show-time :format="'YYYY-MM-DD HH:mm'" :valueFormat="'YYYY-MM-DD HH:mm:59'"
                    style="width: 100%;" v-model="form.expiration" :disabled-date="disabledDate" />
                <div><a-icon :style="{ color: 'red' }" type="question-circle" />一般设置为服务结束时间（注意具体时间）</div>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
export default {
    props: ['trip_id'],
    data() {
        return {
            visible: false,
            labelCol: { span: 7 },
            wrapperCol: { span: 14 },
            confirmLoading: false,
            form: {
                subsId: '',
                username: '',
                phonenumber: '',
                pool_key: undefined,
                expiration: '',
            },
            rules: {
                username: [
                    {
                        required: true,
                        message: "请输入工作人员昵称（姓名）",
                        trigger: "change",
                    },
                ],
                phonenumber: [
                    {
                        required: true,
                        message: "请输入工作人员手机号",
                        trigger: "change",
                    },
                    {
                        pattern: /^(1[3-9]\d{9}|[569]\d{7}|9\d{8})$/,
                        message: "请输入有效的大陆、港澳台手机号",
                        trigger: "change",
                    },
                ],
                pool_key: [
                    {
                        required: true,
                        message: "请选择号码池",
                        trigger: "change",
                    },
                ],
                expiration: {
                    required: true,
                    message: "请选择隐私通过过期时间",
                    trigger: "change",
                },
            },
            disabledDate(current) {
                // 获取当前时间，并加上一分钟
                const oneMinuteLater = new Date();
                oneMinuteLater.setMinutes(oneMinuteLater.getMinutes() + 1);
                // 只能选择比 "当前时间 + 1 分钟" 之后的时间
                return current && current < oneMinuteLater;
            },
            poollist: [],

        };
    },
    methods: {
        init(row) {
            this.visible = true;
            this.getPoolSelect()
            if (row) {
                console.log(row)
                this.form.subsId = row.subsId
                this.form.username = row.nick_name
                this.form.phonenumber = row.phoneB
                this.form.pool_key = row.pool_key
                this.form.expiration = row.expiration
            }
            // if (id) {
            //     this.form.id = row.id
            //     // this.$http({
            //     //     url: '/admin/tripextracosts/info',
            //     //     method: 'post',
            //     //     data: {
            //     //         id: this.form.id
            //     //     }
            //     // }).then(res => {
            //     //     this.form = res.data
            //     // })
            // }
        },
        getPoolSelect() {
            this.$http({
                url: '/admin/trip/poolselect',
                method: 'get',
            }).then(res => {
                this.poollist = res.data
            })
        },
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    this.$http({
                        url: '/admin/trip/groupphoneadd',
                        method: 'post',
                        data: {
                            ...this.form,
                            trip_id: this.trip_id
                        }
                    }).then(() => {
                        this.$message.success(this.form.id ? '修改成功' : '添加成功')
                        this.$emit('ok')
                        this.handleCancel()
                    }).finally(() => {
                        this.confirmLoading = false;
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleCancel() {
            this.visible = false;
            this.$refs.ruleForm.resetFields();
            this.form.subsId = ''
        },
    },
};
</script>